import { Box, IconButton, useTheme } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { ColorModeContext } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { logout, selectUserData } from "../../features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LogoutOutlined } from "@mui/icons-material";
import ShowNotificationModal from "../../models/ShowNoticationsModal";

const Topbar = React.forwardRef((prop, ref: any) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [showNootificationModal, setShowNotificationModal] = useState(false);
  const notification = useSelector(selectUserData).notifications;

  useEffect(() => {
    ref.current.onclick = () => setShowNotificationModal(false);
  }, [ref]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      sx={
        theme.palette.mode === "dark"
          ? { padding: "16px 16px 12px 16px", backgroundColor: "#141b2d" }
          : { padding: "16px 16px 12px 16px", backgroundColor: "#fcfcfc" }
      }
      width={"100%"}
    >
      {/* {SEARCH BAR} */}
      <div></div>
      <div className="flex relative">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton
          onClick={() => setShowNotificationModal((prev: boolean) => !prev)}
        >
          {notification?.length > 0 && (
            <div
              className="w-[5px] h-[5px] rounded"
              style={{ backgroundColor: "red", borderColor: "red" }}
            />
          )}
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton className="relative" onClick={(e) => navigate("/form")}>
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton
          onClick={(e) => {
            localStorage.setItem("userData", JSON.stringify(null));
            dispatch(logout({ token: null }));
          }}
        >
          <LogoutOutlined />
        </IconButton>
        {showNootificationModal && (
          <ShowNotificationModal
            setShowNotificationModal={setShowNotificationModal}
          />
        )}
      </div>
    </Box>
  );
});
export default Topbar;
